function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { getEnvironment, once } from '@sail/utils';
import generateId from '../../helpers/generateId';
import { MissingServiceObservabilityError } from '../../internal/common/errors';
import logErrorInDev from '../../internal/common/logErrorInDev';
import { QA_R_URL, R_URL } from '../../internal/metrics/endpoints';
const HEADERS = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
const logMissingServiceOnce = once(()=>{
    logErrorInDev(new MissingServiceObservabilityError());
});
export default function record(config, metric, params) {
    const service = config.service;
    if (!service) {
        logMissingServiceOnce();
        return;
    }
    // Parameters required by the analytics event logger service
    const requiredParams = {
        client_id: service,
        event_id: generateId(),
        event_name: metric,
        created: `${Math.floor(new Date().getTime() / 1000)}`
    };
    const pageViewToken = config.pageViewToken;
    const url = getEnvironment() === 'production' ? R_URL : QA_R_URL;
    const body = new URLSearchParams(_object_spread({}, params, pageViewToken ? {
        page_view_id: pageViewToken
    } : {}, requiredParams));
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
        navigator.sendBeacon(url, body);
    } else {
        fetch(url, {
            method: 'POST',
            headers: HEADERS,
            mode: 'no-cors',
            keepalive: true,
            body: body.toString()
        });
    }
}

//# sourceMappingURL=record.js.map